import * as React from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { LIST_DEFAULT_PAGE_SIZE } from './contract.js';
/**
 * Stav seznamu dle list-kontraktu nad TanStack Query.
 * Behem prechodu mezi strankami drzi predchozi data (zadne blikani tabulky).
 */
export function useListQuery({ queryKey, initial, fetcher }) {
    const [query, setQueryState] = React.useState({
        page: 1,
        pageSize: LIST_DEFAULT_PAGE_SIZE,
        ...initial,
    });
    const setQuery = React.useCallback((patch) => {
        setQueryState((prev) => {
            const resetPage = patch.filters !== undefined || patch.search !== undefined;
            const merged = { ...prev, ...patch };
            return resetPage && patch.page === undefined ? { ...merged, page: 1 } : merged;
        });
    }, []);
    const result = useQuery({
        queryKey: [...queryKey, query],
        queryFn: () => fetcher(query),
        placeholderData: keepPreviousData,
    });
    return {
        query,
        setQuery,
        data: result.data,
        isLoading: result.isPending,
        isFetching: result.isFetching,
        error: result.error,
        refetch: () => void result.refetch(),
    };
}
//# sourceMappingURL=use-list-query.js.map